export default __webpack_public_path__ + "static/media/transland-trucks.ac88546a.jpg";